module.exports = new __parcel__URL__("BrickfilmersGuild.8b2f74c6.avif").toString();